import { configureStore } from "@reduxjs/toolkit";
import layoutReducer from "./layout";
import themeReducer from "./theme";
import deviceReducer from "./device";
import deviceCommandReducer from "./deviceCommand";
import settingsReducer from "./settings";

export const store = configureStore({
	reducer: {
		layout: layoutReducer,
		theme: themeReducer,
		device: deviceReducer,
		deviceCommand: deviceCommandReducer,
		settings: settingsReducer,
	},
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
